import { CHALLENGES, RESERVE_TYPES } from 'constants'

export default {
    current_clan_result: {
        place: 40,
        points: 400,
        points_lack: null,
        time_in_battle: null,
    },
    meta: {
        calculated_at: require('moment')().subtract(3, 'minutes').valueOf(),
        start_datetime: require('moment')().subtract(3, 'hours').valueOf(),
        end_datetime: require('moment')().subtract(40, 'minutes').valueOf(),
        challenge_id: 30,
        prev_subject_type: CHALLENGES.SHOOTING,
        next_subject_type: CHALLENGES.ONSLAUGHT,
        update_frequency: 60,
    },
    leaderboard: Array.from({ length : 150 }, (item, idx) => ({
        place: idx + 1,
        rewards: {
            gold: 100 - idx,
            credits: 200 - idx,
            reserves: [
                {
                    level: 12,
                    type: RESERVE_TYPES.BATTLE_PAYMENTS,
                    count: 2,
                },
                {
                    level: 12,
                    type: RESERVE_TYPES.TACTICAL_TRAINING,
                    count: 2,
                },
            ],
        },
        clan: {
            color: '#D24D57',
            emblem: 'http://ru.wgnwn.wgnt.iv/sclans/media/clans/emblems/cl_4/4/emblem_24x24.png',
            id: idx + 1,
            name: `clan${idx}`,
            tag: `TAG${idx}`,
            points: 500 - idx,
            time_in_battle: 100,
        },
    })),
    rules: {
        places_count: 3,
        best_battle_multiplier: 7,
        sortie_6: 120,
        sortie_8: 130,
        sortie_10: 140,
        fort_battle: 200,
    },
}



// WEBPACK FOOTER //
// ./containers/ChallengeView/mock.js